<section class="toast-section" *ngIf="mobileViewSection">
  <div class="container">
    <div class="row">
      <div class="col-sm-12 toast-area">
        <span>Crafttor Workspace is best experienced on desktop. To proceed, Log in from a desktop browser.</span>
      </div>
    </div>
  </div>
</section>

<section class="login-section" *ngIf="socialLoginSection">
  <div class="login-left">
    <a routerLink="/home"><img src="assets/img/Logo-blue.svg"></a>
    <div class="multi-imgs">
      <img src="assets/img/com.png">
    </div>
  </div>
  <div class="login-form">
    <a class="for-mob"><img src="assets/img/Logo-blue.svg"></a>
    <div class="form-step">
      <div class="inner-card">
        <h2>Welcome to Crafttor 🎉</h2>
        <p>Continue to login to access your Crafttor Workspace</p>
        <a *ngIf="!showGoogleLoginLoader" class="g-button button" (click)="signInWithGoogle()"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.99992 8.18262V12.0554H15.3818C15.1454 13.3008 14.4362 14.3554 13.3726 15.0645L16.6181 17.5827C18.509 15.8373 19.5999 13.2736 19.5999 10.2282C19.5999 9.5191 19.5363 8.83721 19.4181 8.18273L9.99992 8.18262Z" fill="#4285F4"/>
        <path d="M4.3956 11.9045L3.66363 12.4649L1.07266 14.483C2.71812 17.7466 6.09062 20.0012 9.9997 20.0012C12.6996 20.0012 14.9633 19.1103 16.6179 17.5831L13.3724 15.0649C12.4815 15.6649 11.3451 16.0285 9.9997 16.0285C7.3997 16.0285 5.19066 14.274 4.39969 11.9103L4.3956 11.9045Z" fill="#34A853"/>
        <path d="M1.07266 5.51941C0.39087 6.86482 0 8.38303 0 10.0012C0 11.6194 0.39087 13.1376 1.07266 14.483C1.07266 14.492 4.4 11.9011 4.4 11.9011C4.2 11.3011 4.08179 10.6648 4.08179 10.0011C4.08179 9.33736 4.2 8.70103 4.4 8.10103L1.07266 5.51941Z" fill="#FBBC05"/>
        <path d="M9.99991 3.98184C11.4727 3.98184 12.7817 4.49092 13.8272 5.47276L16.6908 2.60914C14.9544 0.990977 12.7 0 9.99991 0C6.09082 0 2.71812 2.24546 1.07266 5.51822L4.39991 8.10006C5.19077 5.73638 7.39991 3.98184 9.99991 3.98184Z" fill="#EA4335"/>
        </svg> Continue with Google</a>

        <a class="g-button button" *ngIf="showGoogleLoginLoader"><img src="assets/img/img-up.svg" alt="" style="height: 18px;"></a>

        <p>Or continue with</p>
        <form action="your-login-endpoint" [formGroup]="loginForm" (ngSubmit)="loginFunction()" *ngIf="login">
          <div class="form-group">
            <label for="email">Email</label>
            <input type="text" formControlName="email" placeholder="name@email.com"  class="form-control" id="email" name="email" required>
            <span class="text-danger error-text"
              *ngIf="(loginForm.controls.email.touched || submitted) && loginForm.controls.email.errors?.required">
            Email is required
            </span>
            <span class="text-danger error-text"
              *ngIf="(loginForm.controls.email.touched || submitted) && loginForm.controls.email.errors?.pattern">
              Email is not valid
            </span>
          </div>
          <div class="form-group">
            <label for="password">Password</label>
            <input formControlName="password" placeholder="**********" type="password" class="form-control" id="password" name="password" required>
            <span class="text-danger error-text"
              *ngIf="(loginForm.controls.password.touched || submitted) && loginForm.controls.password.errors?.required">
              Password is required
            </span>
          </div>
          <div class="text-right forgot-item">
            <a (click)="forgotScreen()">Forgot Password?</a>
          </div>
          <button type="submit" class="btn btn-primary btn-block" *ngIf="!showLeaveLoader" style="height: 44px;">Login</button>
          <button style="height: 44px;" type="submit" class="btn btn-primary btn-block" *ngIf="showLeaveLoader"><img src="assets/img/img-up-white.svg" alt="" style="height: 18px;"></button>
          <span style="font-size: 12px; color: #ff0000;">{{loginErrorMsg}}</span>
          <div class="mt-3 ">
            Don’t have an account? <a (click)="showEmailVerifyScreen()">Sign Up</a>
          </div>
        </form>

        <form action="your-login-endpoint" [formGroup]="emailVerifyForm" (ngSubmit)="getOTP()" *ngIf="emailVerify">
          <div class="form-group">
            <label for="email">Email</label>
            <input type="text" formControlName="email" placeholder="name@email.com" class="form-control" id="email" name="email" required>
            <span class="text-danger error-text"
              *ngIf="(emailVerifyForm.controls.email.touched || submitted) && emailVerifyForm.controls.email.errors?.required">
            Email is required
            </span>
            <span class="text-danger error-text"
              *ngIf="(emailVerifyForm.controls.email.touched || submitted) && emailVerifyForm.controls.email.errors?.pattern">
              Email is not valid
            </span>
          </div>

          <button type="submit" class="btn btn-primary btn-block" *ngIf="!showLeaveLoader" style="height: 44px;">Get OTP</button>
          <button style="height: 44px;" type="submit" class="btn btn-primary btn-block" *ngIf="showLeaveLoader"><img src="assets/img/img-up-white.svg" alt="" style="height: 18px;"></button>
          <span style="font-size: 12px; color: #a9a9a9;">Enter coupon code when OTP generated successfully!</span>
          <div class="mt-3 ">
            Already have an account? <a (click)="showLoginScreen()">Login</a>
          </div>
          <div class="mt-3 " style="text-align: center">
            By signing up, you agree to our <a (click)="clickTermsAndCondtions()">Terms of use & Privacy policy.</a>
          </div>
        </form>

        <form action="" [formGroup]="signUpForm" (ngSubmit)="checkPasswordLength()" *ngIf="signup">
          <div class="" style="display: flex;">
            <div class="form-group" style="margin-right: 4px;">
              <label for="email">First name</label>
              <input type="text" formControlName="fname" class="form-control" id="email" name="email" required>
              <span class="text-danger error-text"
                *ngIf="(signUpForm.controls.fname.touched || submitt) && signUpForm.controls.fname.errors?.required">
                  First Name is required
              </span>
            </div>
            <div class="form-group" style="margin-left: 4px;">
              <label for="email">Last name</label>
              <input type="text" formControlName="lname" class="form-control" id="email" name="email" required>
              <span class="text-danger error-text"
                *ngIf="(signUpForm.controls.lname.touched || submitt) && signUpForm.controls.lname.errors?.required">
                  Last Name is required
              </span>
            </div>
          </div>

          <div class="form-group">
            <label for="email">Password</label>
            <input type="password" formControlName="password" placeholder="Password must be at least 8 characters" class="form-control" id="password" name="password" required>
            <span class="text-danger error-text"
              *ngIf="(signUpForm.controls.password.touched || submitt) && signUpForm.controls.password.errors?.required">
                Password is required
            </span>

            <span class="text-danger error-text"
              *ngIf="showPasswordError">
              Password must be at least 8 characters long.
            </span>
          </div>

          <div class="form-group">
            <label for="email">OTP</label>
            <input type="text" formControlName="otp" class="form-control" id="otp" name="email" required>
            <span class="text-danger error-text"                *ngIf="(signUpForm.controls.otp.touched || submitt) && signUpForm.controls.otp.errors?.required">
              OTP is required
            </span>
          </div>

          <div class="form-group">
            <label for="coupon">Coupon Code</label>
            <input type="text" formControlName="coupon" class="form-control" id="coupon" name="coupon" placeholder="Enter coupon code">
          </div>

          <div class="form-group">
            <label for="coupon">Stacking Coupons Code <span style="color: #a9a9a9">(Optional)</span></label>
            <div class="" style="display: flex;">
              <input style="margin-right: 4px;" type="text" formControlName="coupon2" class="form-control" id="coupon" name="coupon" placeholder="Coupon 2">

              <input style="margin-left: 4px;" type="text" formControlName="coupon3" class="form-control" id="coupon" name="coupon" placeholder="Coupon 3">
            </div>
            <span style="color: #a9a9a9; font-size: 10px;">You can also add coupon 2 and 3 later in settings.</span>
          </div>

          <button type="submit" class="btn btn-primary btn-block" *ngIf="!showLeaveLoader" style="height: 44px;" (click)="checkPasswordLength()">Get Started</button>
          <button style="height: 44px;" type="submit" class="btn btn-primary btn-block" *ngIf="showLeaveLoader"><img src="assets/img/img-up-white.svg" alt="" style="height: 18px;"></button>
          <span class="text-danger error-text board-error-text" *ngIf="isShowCouponError">{{couponErrorMessage}}</span>

          <span class="text-danger error-text board-error-text" *ngIf="nonUniqueCoupons">Coupons must be unique.</span>

          <div class="mt-3 ">
            Already have an account? <a (click)="showLoginScreen()">Login</a>
          </div>
          <div class="mt-3 " style="text-align: center">
            By signing up, you agree to our <a (click)="clickTermsAndCondtions()">Terms of use & Privacy policy.</a>
          </div>
        </form>

        <form action="" [formGroup]="forgotPasswordForm" (ngSubmit)="forgotPasswordFunction()" *ngIf="forgotpassword">
          <div class="form-group">
            <label for="email">Email</label>
            <input type="text" formControlName="email" placeholder="name@email.com" class="form-control" id="email" name="email" required>
            <span class="text-danger error-text"
            *ngIf="(forgotPasswordForm.controls.email.touched || submittedForm) && forgotPasswordForm.controls.email.errors?.required">
              Email is required
            </span>
            <span class="text-danger error-text"
            *ngIf="(forgotPasswordForm.controls.email.touched || submittedForm) && forgotPasswordForm.controls.email.errors?.pattern">
            Email is not valid
            </span>
          </div>

          <button type="submit" class="btn btn-primary btn-block" *ngIf="!showLeaveLoader" style="height: 44px;">Get OTP</button>
          <button style="height: 44px;" type="submit" class="btn btn-primary btn-block" *ngIf="showLeaveLoader"><img src="assets/img/img-up-white.svg" alt="" style="height: 18px;"></button>
          <span style="font-size: 11px; color: #ff0000;">{{forgotPasswordErrorMsg}}</span>
          <div class="mt-3 ">
            <a (click)="showLoginScreen()">Return to login</a>
          </div>
        </form>

        <form action="" [formGroup]="enterOtpForm" (ngSubmit)="resetPasswordFunction()" *ngIf="enterOtp">
          <div class="form-group">
            <label for="email">OTP</label>
            <input type="text" formControlName="otp" class="form-control" id="otp" name="email" required>
            <span class="text-danger error-text"
              *ngIf="(enterOtpForm.controls.otp.touched || passwordSubmit) && enterOtpForm.controls.otp.errors?.required">
                Enter OTP
            </span>
          </div>

          <div class="form-group">
            <label for="email">Enter password</label>
            <input type="password" formControlName="password" placeholder="**********" class="form-control" id="password" name="email" required>
            <span class="text-danger error-text"
              *ngIf="(enterOtpForm.controls.password.touched || passwordSubmit) && enterOtpForm.controls.password.errors?.required">
                Enter new password
            </span>
          </div>

          <div class="form-group">
            <label for="email">Re-enter password</label>
            <input type="password" formControlName="repassword" placeholder="**********" class="form-control" id="password" name="email" required>
            <span class="text-danger error-text"
              *ngIf="(enterOtpForm.controls.repassword.touched || passwordSubmit) && enterOtpForm.controls.repassword.errors?.required">
                Re-enter password
            </span>
          </div>

          <button type="submit" class="btn btn-primary btn-block" *ngIf="!showLeaveLoader" style="height: 44px;">Reset password</button>
          <button style="height: 44px;" type="submit" class="btn btn-primary btn-block" *ngIf="showLeaveLoader"><img src="assets/img/img-up-white.svg" alt="" style="height: 18px;"></button>
          <span style="font-size: 11px; color: #ff0000;">{{resetPasswordErrorMsg}}</span>
          <div class="mt-3 ">
            <a (click)="showLoginScreen()">Return to login</a>
          </div>
        </form>

        <div class="loader-scenarios" *ngIf="showTopRightLoader">
          <img class="img-up-loader" style="width: 30px;" src="assets/img/img-up.svg" alt="">
        </div>

        <div class="loader-scenarios-success-msgs" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="200" *ngIf="sendSuccessfulMsg">
          <span class="ant-avatar-selected">
            <svg width="18" height="14" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 5L4.58824 9L13 1" stroke="#0fa636" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          <p>{{successfullMessage}}</p>
        </div>

        <div class="loader-scenarios-error-msgs" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="200" *ngIf="sendSuccessfulErrorMsg">
          <p>{{sendSuccessfulErrorMessage}}</p>
        </div>

      </div>
    </div>
    <div class="multi-imgs for-mob">
      <img src="assets/img/com.png">
    </div>
  </div>
</section>

<section class="login-section" *ngIf="tellUsMoreSection">
  <div class="login-left">
    <a routerLink="/home"><img src="assets/img/Logo-blue.svg"></a>
    <div class="multi-imgs">
      <img src="assets/img/com.png">
    </div>
  </div>
  <div class="login-form">
    <a class="for-mob"><img src="img/Logo-blue.svg"></a>
    <div class="form-step">
      <div class="inner-card">
        <h2>Tell us a bit about yourself</h2>
        <p>It helps us to serve you better</p>
        <div class="skip-box step-1">
          <div class="step-form">
            1/1
            <div class="progress-bar">
            </div>
          </div>
          <a (click)="signUpFormFunction()">Skip</a>
        </div>
        <form action="your-login-endpoint" [formGroup]="enterNewDetails" (ngSubmit)="signUpFormFunction()">
          <!-- <div class="form-group">
            <label for="Name">Name</label>
            <input type="text" class="form-control" id="name" name="name">
          </div> -->
          <div class="form-group">
            <label for="organization">Organisation Name</label>
            <input type="text" formControlName="organization" class="form-control" id="organization" name="organization">
          </div>
          <div class="form-group">
            <label for="Phone">Phone Number</label>
            <input maxlength="13" type="number" formControlName="phoneNumber" class="form-control" id="phoneNumber" name="phoneNumber">
          </div>
          <div class="form-group">
            <label for="role">Role/Title</label>
            <select class="options" (change)="selectedRoleTitle($event)">
             <option value="Founder">Founder</option>
             <option value="Sr. Manager">Sr. Manager</option>
             <option value="Product Manager">Product Manager</option>
             <option value="Product Designer">Product Designer</option>
             <option value="Marketing Manager">Marketing Manager</option>
             <option value="Designer">Designer</option>
            </select>
          </div>
          <div class="btn-wrap">
            <a class="btn btn-primary gray-btn" (click)="signUpBackFuntion()">Back</a>
            <button type="submit" class="btn btn-primary" (click)="signUpFormFunction()" *ngIf="!showTellUsLoader">Next</button>
            <button type="submit" class="btn btn-primary" *ngIf="showTellUsLoader"><img src="assets/img/img-up-white.svg" alt="" style="height: 18px;"></button>
          </div>
          <p *ngIf="showTellUsMoreSectionError" class="error" style="color: #ff0000; margin-top: 20px;">{{tellUsMoreSectionErrorMsg}}</p>
        </form>
      </div>
    </div>
    <div class="multi-imgs for-mob">
      <img src="assets/img/com.png">
    </div>
  </div>
</section>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
	padding-top: 150px;"
	class="modal"
	tabindex="-1"
	role="dialog"
	[ngStyle]="{'display':enterCouponCodeStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: 100px;
    width: 35%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="position: relative; padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
			<div class="modal-body new-create-workspace-dialog">
				<button style="margin: -10px;" type="button" class="close" (click)="closeCouponCodeDialog()" data-dismiss="modal" aria-label="Close">
					<img src="assets/img/cross.svg">
				</button>
				<div class="mt-2 share-class-permit">
					<div class="inner-content welcome-txt" style="background-color: #fff">
						<h6>Enter Coupon Code</h6>
						<!-- <p class="create-space-p">Create and customise a workspace as per your requirements.</p> -->
						<div class="create-workspace-txt">
							<p>Coupon Code</p>
						</div>
						<div class="btn-wrapper">
							<form style="width: 100%" class="form-horizontal" [formGroup]="createCoupon" (ngSubmit)="submitCouponWithGoogleLogin(couponCodeValue.value, couponCode2Value.value, couponCode3Value.value)">
								<input formControlName="message" placeholder="Enter coupon code" data-test-name="invite-email-input" class="workspace-ant-input-invite-field" type="text" value="" #couponCodeValue>

                <div class="stacking-coupon-section">
    							<p>Stacking Coupons Code <span style="color: #a9a9a9">(Optional)</span></p>
    						</div>
                <div class="stacking-google-coupon">
                  <input formControlName="coupon2" placeholder="Coupon 2" data-test-name="invite-email-input" class="workspace-ant-input-invite-field coupon-two" type="text" value="" #couponCode2Value>

                  <input formControlName="coupon3" placeholder="Coupon 3" data-test-name="invite-email-input" class="workspace-ant-input-invite-field coupon-three" type="text" value="" #couponCode3Value>
                </div>
                <span style="color: #a9a9a9; font-size: 10px;">You can also add coupon 2 and 3 later in settings.</span>

							</form>
						</div>
						<span class="text-danger error-text board-error-text" *ngIf="isShowCouponError">{{couponErrorMessage}}</span>

            <span class="text-danger error-text board-error-text" *ngIf="nonUniqueCoupons">Coupons must be unique.</span>

						<button *ngIf="!showCouponLeaveLoader" style="width: 100%" data-test-name="send-invite-button" type="button" class="ant-btn-create-org ant-btn-default ant-input-search-button" (click)="submitCouponWithGoogleLogin(couponCodeValue.value, couponCode2Value.value, couponCode3Value.value)"><span role="img" aria-label="plus" class="create-workspace-span">Submit</span></button>

            <!-- <button *ngIf="!showCouponLeaveLoader" style="width: 100%; background: #f4f4f4; border: 1px solid #f4f4f4; color: #a9a9a9" data-test-name="send-invite-button" type="button" class="ant-btn-create-org ant-btn-default ant-input-search-button"><span role="img" aria-label="plus" class="create-workspace-span">Submit</span></button> -->

						<button *ngIf="showCouponLeaveLoader" style="width: 100%" data-test-name="send-invite-button" type="button" class="ant-btn-create-org ant-btn-default ant-input-search-button">
							<img class="img-up-loader" style="height: 18px;" src="assets/img/img-up-white.svg" alt="">
						</button>

						<button type="button" name="button" class="new-workspace-cancel" (click)="closeCouponCodeDialog()">Cancel</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
